import React, { useState } from "react";

import styled from "styled-components";
import { ReactComponent as StarField } from "images/svg/starfield.svg";
import { ReactComponent as BgSvgMobile } from "images/svg/reset-mobile-starfield.svg";
import Typography from "components/typography";
import { Colors } from "utils/colors";

import PrimaryButton from "components/buttons/primary-button";
import Navbar from "../../components/navbar";
import { useNavigate } from "react-router-dom";
import PasswordInput from "components/inputs/password-input";
import api from "services/axiosInstance";
import Toast from "components/toast";
import TextInput from "components/inputs/text-input";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const Confirm = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/password-reset", {
        newPassword,
        confirmPassword,
        token
      });
      Toast({
        response: res
      });
      navigate("/login");
    } catch (e) {
      Toast({ error: e });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container>
      <Navbar />
      <BG>
        <StarField />
      </BG>
      <MBg>
        <BgSvgMobile width={"100%"} height={"100%"} />
      </MBg>
      <Body onSubmit={Confirm}>
        <SvgContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 64 64"
            fill="none"
          >
            <path
              d="M46.8463 27.2618C46.7844 28.067 46.5625 28.8722 46.1909 29.6722L38.8567 25.4347C38.2063 25.058 37.4425 24.8722 36.5651 24.867C35.6876 24.867 34.9289 25.0528 34.2838 25.4244C33.8038 25.7031 33.4992 26.018 33.3805 26.3741C31.5018 26.018 29.4993 25.8425 27.3728 25.8373C22.036 25.827 17.4734 26.9212 13.6747 29.1096C12.2192 29.9509 11.0425 30.8593 10.1444 31.8296C8.83344 30.3947 8.12118 28.8257 8.01796 27.1173C8.00764 26.978 8.00247 26.8386 8.00247 26.6993C7.98699 23.618 9.87602 20.9806 13.6747 18.787C17.4734 16.5986 22.036 15.5044 27.3728 15.5147C32.7044 15.525 37.2825 16.6296 41.107 18.8386C43.5896 20.2735 45.2825 21.9509 46.1909 23.8812C46.7173 25.0064 46.9392 26.1367 46.8463 27.2618Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.03226"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M37.3909 50.3018C37.0502 50.8077 36.4619 51.1277 35.6257 51.2567C31.0167 52.1084 26.3509 52.2167 21.6231 51.5922C16.8954 50.9677 12.7561 49.6309 9.20509 47.5819C4.07993 44.6245 1.5096 41.0993 1.48895 37.0064V26.6838C1.49928 28.5006 2.0154 30.2142 3.03217 31.809C4.11604 33.5122 5.77799 35.0864 8.01799 36.5315C8.39476 36.7793 8.79218 37.0219 9.20509 37.2593C12.7561 39.3084 16.8954 40.6451 21.6231 41.2696C26.3509 41.8941 31.0167 41.7858 35.6257 40.9342C36.3844 40.8155 36.9367 40.5419 37.2877 40.1135C37.3238 40.0722 37.3599 40.0257 37.3909 39.9793C37.5302 39.7728 37.6025 39.5716 37.6128 39.3755V49.5638C37.6386 49.8012 37.5612 50.0489 37.3909 50.3018Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.03226"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M62.6916 26.8078V37.1201C62.6968 37.6259 62.3716 38.0646 61.7265 38.4362L50.3355 45.0169C49.6903 45.3885 48.9264 45.5743 48.0541 45.5691C47.1767 45.5691 46.4129 45.3833 45.7625 45.0065L37.6129 40.2994V39.2465C37.5974 39.0039 37.4787 38.7614 37.2671 38.5291C36.8852 38.0904 36.3122 37.7704 35.5483 37.5691C34.8567 37.3885 34.1393 37.342 33.3858 37.4401C33.3445 37.3214 33.3187 37.1923 33.3187 37.0633V26.7407C33.3238 27.2465 33.649 27.6904 34.2994 28.062L45.7625 34.6839C46 34.8181 46.2477 34.9317 46.5161 35.0194C46.9806 35.1691 47.4967 35.2465 48.0541 35.2465C48.9264 35.2517 49.6903 35.0659 50.3355 34.6943L52.4826 33.4504L61.7265 28.1136C62.3665 27.7472 62.6916 27.3085 62.6916 26.8078Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.03226"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M62.6916 26.7974V26.8077C62.6916 27.3084 62.3664 27.7471 61.7264 28.1135L52.4826 33.4503L50.3354 34.6942C49.6903 35.0658 48.9264 35.2516 48.0541 35.2464C47.4967 35.2464 46.9806 35.169 46.5161 35.0193C46.2477 34.9316 45.9999 34.8181 45.7625 34.6839L34.2993 28.0619C33.649 27.6903 33.3238 27.2464 33.3186 26.7406C33.3186 26.6116 33.3393 26.4877 33.3806 26.3742C33.4993 26.0181 33.8038 25.7032 34.2838 25.4245C34.929 25.0529 35.6877 24.8671 36.5651 24.8671C37.4425 24.8723 38.2064 25.0581 38.8567 25.4348L46.1909 29.6723C46.5625 28.8723 46.7844 28.0671 46.8464 27.2619C46.9393 26.1368 46.7174 25.0064 46.1909 23.8813C45.2825 21.951 43.5896 20.2735 41.107 18.8387C37.2825 16.6297 32.7044 15.5252 27.3728 15.5148C22.0361 15.5045 17.4735 16.5987 13.6748 18.7871C9.87606 20.9806 7.98703 23.6181 8.00251 26.6993C8.00251 26.8387 8.00767 26.9781 8.018 27.1174C8.12122 28.8258 8.83348 30.3948 10.1444 31.8297C11.058 32.831 12.2657 33.76 13.7625 34.6271C16.3586 36.129 19.3935 37.12 22.8619 37.6103C26.3303 38.1006 29.7625 38.0542 33.1483 37.4658C33.2257 37.4555 33.3083 37.44 33.3857 37.44C34.1393 37.3419 34.8567 37.3884 35.5483 37.569C36.3122 37.7703 36.8851 38.0903 37.267 38.529C37.4786 38.7613 37.5974 39.0039 37.6128 39.2464V39.3755C37.6025 39.5716 37.5303 39.7729 37.3909 39.9793C37.3599 40.0258 37.3238 40.0723 37.2877 40.1135C36.9367 40.5419 36.3844 40.8155 35.6257 40.9342C31.0167 41.7858 26.3509 41.8942 21.6232 41.2697C16.8954 40.6452 12.7561 39.3084 9.20509 37.2593C8.79219 37.0219 8.39477 36.7793 8.018 36.5316C5.778 35.0864 4.11606 33.5123 3.03219 31.809C2.01541 30.2142 1.49929 28.5006 1.48896 26.6839C1.46316 22.5961 3.99734 19.0813 9.08638 16.1393C14.1754 13.2026 20.2657 11.7419 27.3522 11.7523C34.4386 11.7677 40.5393 13.249 45.6644 16.2064C48.3019 17.729 50.2786 19.4993 51.6051 21.5123C52.9316 23.5303 53.4477 25.6155 53.1535 27.7677L57.1432 25.4658C57.7884 25.0942 58.5471 24.9084 59.4245 24.9084C60.3019 24.9135 61.0658 25.0993 61.7161 25.4761C62.3613 25.8477 62.6916 26.2916 62.6916 26.7974Z"
              fill="#FFE8A6"
              stroke="#FFBE00"
              stroke-width="1.03226"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgContainer>
        <Typography
          size="4xl"
          weight="semibold"
          mb="0.8"
          color={Colors.white100}
        >
          Password Reset
        </Typography>
        <Typography mb="2.4" color={Colors.grey400}>
          Please enter your new password twice so we can verify you typed it in
          correctly.
        </Typography>
        <InputItem>
          <TextInput
            label="Token"
            placeholder="Enter Token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
        </InputItem>
        <InputItem>
          <PasswordInput
            label="New Password"
            placeholder="Enter Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </InputItem>
        <InputItem>
          <PasswordInput
            label="Confirm Password"
            placeholder="Enter Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </InputItem>

        <PrimaryButton
          text="Reset password"
          inset
          type="submit"
          loading={loading}
        />
      </Body>
    </Container>
  );
};

export default ResetPassword;

const Container = styled.main`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BG = styled.div`
  position: absolute;
  width: 100%;
  left: -8.2%;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const MBg = styled.div`
  display: none;
  width: 100%;
  position: absolute;
  height: fit-content;

  @media only screen and (max-width: 769px) {
    display: block;
  }
`;
const Body = styled.form`
  width: 58rem;
  padding: 1.6rem;
  padding-bottom: 2.4rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 13.3rem;
  border-radius: 0.8rem;
  border: 1px solid #4e4c44;
  background: rgba(30, 30, 30, 0.8);
  position: relative;
  text-align: center;
  @media only screen and (max-width: 769px) {
    width: 90%;
  }
`;

const SvgContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
  width: 6.4rem;
  height: 6.4rem;
`;

const InputItem = styled.div`
  margin-bottom: 2.4rem;
`;
